import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TAcceptedFilesProps } from '@/shared/components/ui/form/components/file-dropzone/components/accepted-files/accepted-files.types';

export const AcceptedFiles: React.FC<TAcceptedFilesProps> = ({
  acceptedFileTypes,
}) => {
  const { t } = useTranslation();

  if (acceptedFileTypes?.length === 0 || acceptedFileTypes.includes('*')) {
    return null;
  }

  return (
    <Typography variant="p10" color="textSecondary">
      {t('ui:supported_file_types', {
        fileTypes: acceptedFileTypes.join(', '),
      })}
    </Typography>
  );
};
